import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Password Recovery", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "info mb-5" }, "Enter a new password for your account", -1)
const _hoisted_3 = {
  key: 1,
  class: "auth__form"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-2" }, "Success", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "info mb-4" }, "Your password has been changed", -1)

import { useAccountStore } from '@/stores/account';
import { parseQuery } from '@/utils/api-utils';
import { useErrors } from '@/utils/use-errors';
import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import LockIcon from '../icons/other/LockIcon.vue';
import VAuthInput from '../VAuthInput.vue';
import VButton from '../VButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthRecoverForm',
  setup(__props) {

const values = reactive({ password: "", password_repeat: "" })
const { errors, checkRequired } = useErrors(values)

const pending = ref(false)
const mode = ref<"recover" | "success">("recover")
const accountStore = useAccountStore()

const { token } = parseQuery(window.location.search)

const apply = async (e: Event) => {
  e.preventDefault()
  if (!checkRequired([ 'password' ])) return
  if (values.password !== values.password_repeat) {
    errors.password_repeat = "Passwords don't match!"
    return
  }
  pending.value = true
  try {
    await accountStore.recoverPassword({ ...values, token: token as string })
    mode.value = "success"
  } catch(e) {
    console.warn(e)
    errors.password = (e as any)?.body?.message || "Something wrong"
    pending.value = false
  }
}

const router = useRouter()
const goToLogIn = () => {
  router.push("/")
}



return (_ctx: any,_cache: any) => {
  return (mode.value === 'recover')
    ? (_openBlock(), _createElementBlock("form", {
        key: 0,
        class: "auth__form",
        onSubmit: apply
      }, [
        _hoisted_1,
        _hoisted_2,
        _createVNode(VAuthInput, {
          modelValue: values.password,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((values.password) = $event)),
          error: _unref(errors).password,
          icon: LockIcon,
          placeholder: "New Password",
          type: "password"
        }, null, 8, ["modelValue", "error"]),
        _createVNode(VAuthInput, {
          modelValue: values.password_repeat,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((values.password_repeat) = $event)),
          error: _unref(errors).password_repeat,
          icon: LockIcon,
          placeholder: "New Password",
          type: "password"
        }, null, 8, ["modelValue", "error"]),
        _createVNode(VButton, {
          class: "primary mt-4",
          type: "submit",
          disabled: pending.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("Confirm")
          ]),
          _: 1
        }, 8, ["disabled"])
      ], 32))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createVNode(VButton, {
          class: "primary mt-4",
          onClick: goToLogIn
        }, {
          default: _withCtx(() => [
            _createTextVNode("Back to Log In")
          ]),
          _: 1
        })
      ]))
}
}

})